<template>
  <div style="width=100wv; heiht: 100vh;">
    <!-- <h2>
      Это демонстрационный стенд для тестирования всплывающего баннера. <br />
      Баннер вылезает при каждом {{ freq }} посещении. <br />
      После нажатия на донат будет пропущено {{ skip }} посещений.
      <br />
      <br />
      Посещений: {{ visited }}
    </h2>
    <br />
    <Button @click="refresh()">обновить</Button>-->
    <Modal transparent v-model="opened" :closeOnMask="false">
      <div
        style="align-items: center; text-align: center;  display: table; margin: 0 auto;"
        :style="{
          transform: 'scale(' + scale + ')',
          'transform-origin': 'center top'
        }"
      >
        <div class="bannerHeader" :style="{ opacity: exited ? 0 : 1 }"></div>
        <div
          class="bannerBody"
          style="display: table; height: 350px; overflow: hidden;"
          :style="{ opacity: exited ? 0 : 1 }"
        >
          <div class="bannerText">
            {{ text }}
            <br />
            <br />
          </div>
        </div>
        <div :style="{ opacity: exited ? 0 : 1 }" style="transition: all 1s;
">
          <div class="bannerButton" @click="action">
            <h2>Помочь сайту Маскулист</h2>
          </div>
          <br />
          <div
            class="bannerButton"
            @click="cancel"
            style="background-image: linear-gradient(#aaa, #ccc);"
          >
            <h2>Напомнить позже</h2>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
/* eslint-disable no-console */

export default {
  components: {},
  data() {
    return {
      text: `
              В связи с возросшей нагрузкой на сайт, сайту Маскулист теперь
              потребуется регулярная дополнительная НЕ БЕСПЛАТНАЯ техническая
              поддержка. Продолжит ли сайт существование - зависит от Вас, от
              вашей материальной поддержки.`,
      opened: false,
      value: undefined,
      exited: false,
      visited: 0,
      donated: 0,
      freq: 2,
      skip: 40,
      scale: 1
    };
  },
  created() {
    // let img1 = new Image();
    // img1.src = '/banner/img/uc.png';
    // let img2 = new Image();
    // img2.src = '/banner/img/dry-brush-stroke-24.png';
    console.log(window.innerHeight);
    this.scale = window.innerHeight / 1000;
    console.log(this.scale);
  },
  mounted() {
    this.visited = parseInt(getCookie("visited")) || 0;
    this.donated = parseInt(getCookie("donated")) || -1000;
    this.visited++;
    setCookie("visited", this.visited, 365);
    if (
      this.visited % this.freq == 0 &&
      this.donated + this.skip < this.visited
    ) {
      setTimeout(() => {
        this.opened = true;
      }, 1000);
    }
  },
  methods: {
    refresh() {
      window.open("/", "_self");
    },
    cancel() {
      this.exited = true;
      this.text = "Спасибо за Вашу поддержку";
      setTimeout(() => {
        this.opened = false;
      }, 3000);
    },
    action() {
      setCookie("donated", this.visited, 365);
      this.text = "Спасибо за Вашу поддержку";
      this.exited = true;
      setTimeout(() => {
        window.open("http://masculist.ru/info/donate.html", "_self");
      }, 3000);
    }
  }
};

/* eslint-disable */

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
</script>

<style>
.bannerButton {
  transition: all 1s;
  z-index: 50;
  position: relative;
  top: -180px;
  border-radius: 25px;
  padding: 1px;
  margin-left: 5px;
  margin-right: 5px;
  background-image: linear-gradient(#fc4, #fe5);
  box-shadow: -1px 1px 7px #0009;
  /* border: 1px solid #000; */
}

.bannerButton:hover {
  transition: all 0.2s;
  transform: scale(1.03);
  box-shadow: -3px 3px 10px #000;
}

.bannerBody {
  transition: all 1s 2s;
  z-index: 50;
  position: relative;
  top: -120px;
  /* border: 1px solid #000; */
  background-image: url("./assets/dry-brush-stroke-24.png");
  color: antiquewhite;
  text-align: center;
  align-items: center;
  width: 700px;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: 700px;
}

.bannerText {
  padding: 40px;
  display: table-cell;
  vertical-align: middle;
  font-size: 1.6em;
  margin-left: 30px;
  margin-right: 30px;
}

.bannerHeader {
  transition: all 1s 1s;
  z-index: 100;
  position: relative;
  /* border: 1px solid #000; */
  background-image: url("./assets/uc.png");
  color: antiquewhite;
  text-align: center;
  align-items: center;
  width: 700px;
  height: 300px;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: 600px;
  /* padding: 50px; */
  padding-top: 50px;
}

.h-modal {
  height: 100vh;
  width: 100vw;
  background-color: #0007;
}
</style>
